module.exports = __webpack_public_path__ + "static/media/NZ_Primary_White_RGB.e2f4eeb1.png";